import i18n from "../i18n";

export default {
  updateUser: ({ commit }, payload) => {
    commit("getUser", payload);
  },
  initCustomerPlan: ({ commit }, payload) => {
    commit("getCustomerPlan", payload);
  },
  updateCustomerPlan: ({ commit }, payload) => {
    commit("setCustomerPlan", payload);
  },
  updateBalance: ({ commit }, payload) => {
    commit("getBalance", payload);
  },
  updateWalletBalance: ({ commit }, payload) => {
    commit("getWalletBalance", payload);
  },
  initAllPlan: ({ commit }) => {
    commit("setAllPlan");
  },
  initTablePrice: ({ commit }) => {
    commit("setTablePrice");
  },
  setClientKey: ({ commit }, payload) => {
    commit("updateClientKey", payload);
  },
  setAudioInfo: ({ commit }, payload) => {
    commit("updateAudioInfo", payload);
  },
  setFileInfo: ({ commit }, payload) => {
    commit("updateFileInfo", payload);
  },
  deleteUser: ({ commit }) => {
    commit("clearUser");
  },
  play: ({ commit }) => {
    commit("updatePlaying", true);
  },
  pause: ({ commit }) => {
    commit("updatePlaying", false);
  },
  playAllPlay: ({ commit, state }) => {
    commit("updateAllPlay", true);
    if (state["currentAudioId"] !== null) {
      commit("updatePlaying", true);
    }
  },
  pauseAllPlay: ({ commit }) => {
    commit("updateAllPlay", false);
  },
  stopAllPlay: ({ commit }) => {
    commit("updateAllPlay", false);
    commit("updateCurrentAudioId", null);
  },
  changeCurrentId: ({ commit }, payload) => {
    commit("updateCurrentAudioId", payload);
  },
  changeSelectedProject: ({ commit }, payload) => {
    commit("updateSelectedProject", payload);
  },
  showSuccessMessage: ({ commit }, { message, timeout }) => {
    commit("updateSuccessMessage", { state: true, message: message, timeout });
  },
  showBuySuccessMessage: ({ commit }, { message, timeout }) => {
    commit("updateBuySuccessMessage", {
      state: true,
      message: message,
      timeout,
    });
  },
  clearSuccessMessage: ({ commit }) => {
    commit("updateSuccessMessage", { state: false, message: "" });
  },
  showErrorMessage: ({ commit }, { message, timeout }) => {
    commit("updateErrorMessage", { state: true, message: message, timeout });
  },
  clearErrorMessage: ({ commit }) => {
    commit("updateErrorMessage", { state: false, message: "" });
  },
  showWarningMessage: ({ commit }, { message, timeout }) => {
    commit("updateWarningMessage", { state: true, message: message, timeout });
  },
  clearWarningMessage: ({ commit }) => {
    commit("updateWarningMessage", { state: false, message: "" });
  },
  /* Алдаануудыг шалгах функц*/
  checkError: ({ commit }, payload) => {
    if (payload.response === undefined) {
      commit("updateErrorMessage", {
        state: true,
        message: i18n.t("errorMsgs.errorMsg1"),
      });
      return;
    }
    switch (payload.response.status) {
      case 400:
        commit("updateErrorMessage", {
          state: true,
          message: this.$t("errorMsgs.errorMsg1"),
          timeout: 3000,
        });
        break;
      case 402:
        var errorCode = payload.response.data.code;
        if (typeof errorCode != "undefined") {
          if (errorCode == 40201) {
            commit("updateErrorMessage", {
              state: true,
              message: i18n.t("errorMsgs.errorMsg3"),
              timeout: 3000,
            });
          } else if (errorCode == 40200) {
            commit("updateErrorMessage", {
              state: true,
              message: i18n.t("errorMsgs.errorMsg4"),
              timeout: 3000,
            });
          } else if (errorCode == 40202) {
            commit("updateErrorMessage", {
              state: true,
              message: i18n.t("errorMsgs.errorMsg5"),
              timeout: 3000,
            });
          } else if (errorCode == 40203) {
            commit("updateErrorMessage", {
              state: true,
              message: i18n.t("errorMsgs.errorMsg6"),
              timeout: 3000,
            });
          } else if (errorCode == 4005) {
            commit("updateErrorMessage", {
              state: true,
              message: i18n.t("errorMsgs.errorMsg7"),
              timeout: 3000,
            });
          }
        }
        break;
      case 401:
      case 403:
        commit("userLogOut", payload);
        break;
      case 409:
        commit("updateErrorMessage", {
          state: true,
          message: i18n.t("errorMsgs.errorMsg8"),
          timeout: 3000,
        });
        break;
      default:
        commit("updateErrorMessage", {
          state: true,
          message: i18n.t("errorMsgs.errorMsg1"),
          timeout: 3000,
        });
    }
  },
  setSynthState: ({ commit }, payload) => {
    commit("updateSynthesizeState", payload);
  },
  setFocusedFileId: ({ commit }, payload) => {
    commit("updateFocusedFileId", payload);
  },
  setWarningFileDialog: ({ commit }, payload) => {
    commit("updateWarningFileDialog", payload);
  },
};
